import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ReactComponent as Toggle } from '../../../webcommon/common/Icons/Toggle-On.svg';
import { noop } from 'lodash';
import defaultStyles from './ToggleSwitch.module.scss';

const ToggleSwitch = props => (
    <div
        className={ props.styles.gridHeaderButton }
    >
        <div className={ props.styles.textLeft }>{props.optionLeft}</div>
        <button
            type="button"
            onClick={ props.toggleSwitch }
            className={ classnames({
                [props.styles.toggleLeft]: props.toggleIsLeft,
                [props.styles.toggleButton]: true
            }) }
        ><Toggle />
        </button>
        <div className={ props.styles.textRight }>{props.optionRight}</div>
    </div>
);

ToggleSwitch.propTypes = {
    optionLeft: PropTypes.string,
    optionRight: PropTypes.string,
    styles: PropTypes.objectOf(PropTypes.string),
    toggleIsLeft: PropTypes.bool,
    toggleSwitch: PropTypes.func
};

ToggleSwitch.defaultProps = {
    optionLeft: '',
    optionRight: '',
    styles: defaultStyles,
    toggleIsLeft: true,
    toggleSwitch: noop
};

export default ToggleSwitch;
